import React, { useCallback, useState } from "react";
import { Collapse, makeStyles, Typography, ButtonBase, Checkbox } from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import PriceSlider from "../PriceSlider";
import useFilters from "hooks/useFilters";

export default function Filter({ filter }) {
  const classes = useStyle();
  const [{ filters: selectedFilters }, dispatch] = useFilters();
  const [openOptions, setOpenOptions] = useState(false);

  const handleChangeItem = useCallback(
    (slug, isSelected) => {
      if (isSelected) {
        dispatch({ type: "remove", filter: filter.id, value: slug });
      } else {
        dispatch({ type: "add", filter: filter.id, value: slug });
      }
    },
    [dispatch, filter]
  );

  const selfSelectedFilters = selectedFilters[filter.id] || [];

  if (filter.id === "price") {
    return (
      <div className={classes.container}>
        <ButtonBase disableRipple onClick={() => setOpenOptions((prev) => !prev)} className={classes.button}>
          <Typography className={classes.title}>
            {`${filter.name}${
              selectedFilters.price_min?.length && selectedFilters.price_max?.length
                ? ` (${selectedFilters.price_min[0] / 100} - ${selectedFilters.price_max[0] / 100} €)`
                : ""
            }`}
          </Typography>
          <ArrowBackIosIcon className={classes.arrowIcon} />
        </ButtonBase>
        <Collapse in={!openOptions}>
          <PriceSlider min={filter.min} max={filter.max} />
        </Collapse>
      </div>
    );
  }
  return (
    <div className={classes.container}>
      <ButtonBase onClick={() => setOpenOptions((prev) => !prev)} className={classes.button} disableRipple>
        <Typography className={classes.title}>
          {`${filter.name}${selfSelectedFilters.length > 0 ? ` (${selfSelectedFilters.length})` : ""}`}
        </Typography>
        <ArrowBackIosIcon className={classes.arrowIcon} />
      </ButtonBase>
      <Collapse in={openOptions}>
        <div className={classes.choices}>
          {filter.values
            .sort((filter, prev) => {
              if (filter.slug > prev.slug) {
                return 1;
              }
              return -1;
            })
            .map((value) => {
              const isSelected = selfSelectedFilters.includes(value.slug);
              return (
                <ButtonBase
                  key={value.slug}
                  onClick={() => handleChangeItem(value.slug, isSelected)}
                  disableRipple
                  className={classes.valueContainer}
                >
                  <Checkbox checked={isSelected} />
                  <Typography>{value.name}</Typography>
                </ButtonBase>
              );
            })}
        </div>
      </Collapse>
    </div>
  );
}

const useStyle = makeStyles((theme) => ({
  container: {
    position: "relative",
    marginTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid #D7D7D7",
  },
  arrowIcon: {
    transform: "rotateZ(-90deg)",
    fontSize: 20,
  },
  button: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
  },
  choices: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    marginTop: theme.spacing(3),
  },
  title: {
    fontWeight: 500,
  },
  valueContainer: {
    marginBottom: theme.spacing(2),
    width: "100%",
    justifyContent: "flex-start",
    "& .MuiCheckbox-root": {
      paddingLeft: 0,
    },
  },
}));
